import { $axios } from "@/util/axios";

/**
 * 登录
 * @param {*} params{
 userName 		登陆手机	query 	string
password 		登陆密码	query 	string
 * }
 * @return {
  "code": "string",
  "data": {},
  "msg": "string"
    *}
 */
export const login = params => {
  return $axios.post("/login",
    new URLSearchParams(params));
};

/**
 * 登出
 * @param {*} 
* @return{
  "code": "string",
  "data": {},
  "msg": "string"
}
 */
export const logout = () => {
  return $axios.post(
    "/logout"
  );
};

/**
 * 修改密码
 * @param {*} params{
editPwdVO：{
  "newPassword": "string",
  "oldPassword": "string",
  "repeatNewPassword": "string"
}
 * }
* @return{
  "code": "string",
  "data": {},
  "msg": "string"
}
 */
export const updatePwd = params => {
  return $axios.post(
    "/updatePwd",
    new URLSearchParams(params)
  );
};


// WEBPACK FOOTER //
// ./src/api/dengLu.js